import { MusicNote } from '@mui/icons-material'
import MusicEdit from './MusicEdit'
import MusicCreate from './MusicCreate'
import MusicList from './MusicList'

const musicIndex = {
  icon: MusicNote,
  list: MusicList,
  edit: MusicEdit,
  create: MusicCreate,
}

export default musicIndex
